import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { MachineTypeSettingsResponse } from '../types/machine-setup-types';

export class GetTypeSettingsUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(): Promise<MachineTypeSettingsResponse> {
    return this.repository.getTypeSettings();
  }
}
